import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router";
import { Crypt } from "../../utils/Crypt";
import { Grid, Typography } from "@mui/material";
import { ROUTES } from "../../constants/routes";
import { useTranslation } from "react-i18next";
import { datadogLogs } from "@datadog/browser-logs";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { commonActions } from "../../redux/features/common/commonSlice";
import BusinessReportDataApi from "./services/businessReportService";
import CONSTANTS from "../../constants/constants";
import { urlData } from "../../interfaces/businessReportInterface";

const BusinessReportFileDownload = (props: any) => {

    const { showSnackbar } = props;
    const { t } = useTranslation();

    const location = useLocation();
    const crypt = new Crypt();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();

    const params = new URLSearchParams(location.search);
    const downloadId = params.get("download_token");
    const reportType = params.get("reportType");
    const isDemoUserFromLink = params.get("demoUser") === "true";
    const decodedDownloadId = decodeURI(downloadId? downloadId :"");
    const isDemoUser = isDemoUserFromLink || useAppSelector((state) => state.common.demoUser) || false;
    const downloadIdUrl =decodedDownloadId.replace(/\s/g, "+");
    const downloadIdUrlDecryptedValue = crypt.decryptWithCryptoJS(downloadIdUrl,process.env.REACT_APP_ENCRYPTION_IV);
    const isOrderReport = reportType === "order";

    const navigateToBusinessReport = (tabValue: string) => {
        dispatch(commonActions.IS_TAB_URL(tabValue));
        navigate(ROUTES.BUSINESS_REPORT);
    };

    const navigateToBusinessReportError = (tabValue: string) => {
        dispatch(commonActions.IS_TAB_URL(tabValue));
        isDemoUser ? navigate(`${ROUTES.ERROR_DOWNLOAD_BUSINESS_REPORT}?demoUser=true`) : navigate(ROUTES.ERROR_DOWNLOAD_BUSINESS_REPORT);
    };

    const triggerReportDownload = (tabValue: string, url: string = downloadIdUrlDecryptedValue) => {
        const link = document.createElement("a");
        link.href = url;
        link.click();
        navigateToBusinessReport(tabValue);
    };

    const downloadOrderReport = () => {
        triggerReportDownload(`${CONSTANTS.ORDER_TAB}`);
    };

    const downloadProductReport = () => {
        triggerReportDownload(`${CONSTANTS.PRODUCT_TAB}`);
    };

    const getApicall = () => {
        const payload = {};
        const isHitDummyURL = false;
        const tabValue = isOrderReport ? `${CONSTANTS.ORDER_TAB}` : `${CONSTANTS.PRODUCT_TAB}`;
        new BusinessReportDataApi(payload, isHitDummyURL, isDemoUser)
            .linkRegisterUrl(downloadIdUrlDecryptedValue)
            .then(async (res: urlData) => {
                if (res && res.headUrl && res.getUrl) {
                    const isHeadValid = await new BusinessReportDataApi(payload, isHitDummyURL, isDemoUser)
                        .downloadBusinessReportResponseCheck(res.headUrl);
                    if (isHeadValid) {
                        triggerReportDownload(tabValue, res.getUrl);
                    } else {
                        navigateToBusinessReportError(tabValue);
                    }
                } else {
                    navigateToBusinessReportError(tabValue);
                }
            })
            .catch((err) => {
                datadogLogs.logger.error(err);
                showSnackbar(err instanceof Error ? err.message : "", false);
            });
    };

    useEffect(() => {
        if (downloadIdUrlDecryptedValue != "") {
            getApicall();
        } else {
            navigateToBusinessReportError(isOrderReport ?  `${CONSTANTS.ORDER_TAB}` : `${CONSTANTS.PRODUCT_TAB}`);
        }
    }, []);

    return (
        <>
            <Grid container justifyContent={"center"} sx={{ pt: 30 }}>
                <Typography fontSize={50}>{t("verify_invitation.please_wait")}</Typography>
            </Grid>
        </>
    );
};

export default BusinessReportFileDownload;
